"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyV3Alerts = void 0;
const zod_1 = require("zod");
exports.legacyV3Alerts = zod_1.z.object({
    alertIds: zod_1.z.array(zod_1.z.string()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        alertId: zod_1.z.literal(true).optional(),
        alertType: zod_1.z.literal(true).optional(),
        blockIds: zod_1.z.literal(true).optional(),
        createdAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        endDate: zod_1.z.literal(true).optional(),
        frequencyMinutes: zod_1.z.literal(true).optional(),
        insectId: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        notifyOwnerByEmail: zod_1.z.literal(true).optional(),
        notifyOwnerBySMS: zod_1.z.literal(true).optional(),
        propertyIds: zod_1.z.literal(true).optional(),
        sleepMinutes: zod_1.z.literal(true).optional(),
        snoozeAllUntil: zod_1.z.literal(true).optional(),
        snoozeUntil: zod_1.z.literal(true).optional(),
        startDate: zod_1.z.literal(true).optional(),
        stationGeoms: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        contacts: zod_1.z
            .object({
            contactId: zod_1.z.literal(true).optional(),
            contactViaEmail: zod_1.z.literal(true).optional(),
            contactViaSMS: zod_1.z.literal(true).optional(),
            email: zod_1.z.literal(true).optional(),
            language: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            sms: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the alert's contacts",
        }),
        groups: zod_1.z
            .object({
            contactViaEmail: zod_1.z.literal(true).optional(),
            contactViaSMS: zod_1.z.literal(true).optional(),
            groupId: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            contactsForGroup: zod_1.z
                .object({
                contactId: zod_1.z.literal(true).optional(),
                email: zod_1.z.literal(true).optional(),
                language: zod_1.z.literal(true).optional(),
                name: zod_1.z.literal(true).optional(),
                sms: zod_1.z.literal(true).optional(),
            })
                .optional()
                .refine((args) => !args || !!Object.keys(args || {}).length, {
                message: "Must request at least one attribute of the alert's groups' contacts",
            }),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the alert's groups",
        }),
        alertRules: zod_1.z
            .object({
            key: zod_1.z.literal(true).optional(),
            ruleId: zod_1.z.literal(true).optional(),
            operator: zod_1.z.literal(true).optional(),
            unit: zod_1.z.literal(true).optional(),
            value: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: "Must request at least one attribute of the alert's rules",
        }),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the alert if specifying any at all',
    }),
});
//# sourceMappingURL=legacyV3Alerts.js.map